import React from "react";
import { useParams } from "react-router-dom";
import SideNavArrows from "../../../../components/molecules/SideNavArrows/SideNavArrows";
import useSpendingDemandListNavigation from "../../hooks/useSpendingDemandListNavigation";

/**
 * Encadre la page détail d'une demande de dépense avec des flèches
 * pour passer à la demande précédente / suivante de la liste d'origine
 */
export default function SpendingDemandNavigator({
  basePath,
  children,
}: {
  basePath: string;
  children: React.ReactNode;
}) {
  const { spendingDemandId } = useParams();
  const { isEnabled, goToPrevious, goToNext, position, total } =
    useSpendingDemandListNavigation(spendingDemandId, basePath);

  if (!isEnabled) {
    return <>{children}</>;
  }

  const positionInfo = position && total ? ` (${position} / ${total})` : "";

  return (
    <SideNavArrows
      onPrevious={goToPrevious}
      onNext={goToNext}
      previousLabel={`Demande précédente${positionInfo}`}
      nextLabel={`Demande suivante${positionInfo}`}
    >
      {children}
    </SideNavArrows>
  );
}
